import React from "react";

import { useGetUserInfo } from "api/api-hooks/user-hooks";
import {
  GroupingType,
  ProcessedUserData,
  secondsToHm,
} from "components/pages/users-statistics-dashboard/stats-utils";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { T } from "services/lang/LanguageService";

function UserStatisticsDatatable({
  userSessionData,
  groupBy,
}: {
  userSessionData: ProcessedUserData[];
  groupBy: GroupingType;
}) {
  const totalTimeBodyTemplate = (rowData: ProcessedUserData) => {
    return secondsToHm(rowData.totalSessionTime);
  };

  const userBodyTemplate = (rowData: ProcessedUserData) => <UserBodyTemplate rowData={rowData} />;

  const averageTimeBodyTemplate = (rowData: ProcessedUserData) => {
    return secondsToHm(rowData.averageSessionDuration || 0);
  };

  const isGroupedByJob = groupBy === "jobTitle";

  return (
    <div className="mt-2">
      <DataTable value={userSessionData} removableSort size="small" scrollable scrollHeight="350px">
        {!isGroupedByJob && <Column field="user" header={T("word.user")} body={userBodyTemplate} />}
        <Column field="jobTitle" header={T("label.job-title")} body={rowData => rowData.jobTitle || "-"} />
        <Column
          field="totalSessionTime"
          header={T("label.total-time-logged-in")}
          body={totalTimeBodyTemplate}
          sortable
        />
        <Column
          field="averageSessionDuration"
          header={T("label.averarge-time-logged-in")}
          body={averageTimeBodyTemplate}
          sortable
        />
        <Column field="totalSessions" header={T("label.login-count")} sortable />
        <Column field="activeDaysCount" header={T("label.active-days")} sortable />
      </DataTable>
    </div>
  );
}

export default UserStatisticsDatatable;

const UserBodyTemplate: React.FC<{ rowData: ProcessedUserData }> = ({ rowData }) => {
  const userInfo = useGetUserInfo(rowData.user);
  return userInfo.data?.displayName;
};
